import { CardTitle } from '@/components/Shares/CardTitle';
import { CarouselLayout } from '@/components/Shares/CarouselLayout';
import { useLingui } from '@lingui/react';
import { Grid } from '@mantine/core';
import { VipAchievementCard } from './VipAchievementCard';
import { VipAchievementItem } from './VipAchievementItem';
import { achievements } from './data';
export const VipAchievements: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Grid gutter={20} mt={10}>
      <Grid.Col span={{
      base: 12,
      md: 6
    }}>
        <VipAchievementCard />
      </Grid.Col>

      <Grid.Col span={{
      base: 12,
      md: 6
    }}>
        <CarouselLayout id="achievements" items={achievements} slideSize={{
        base: '30%',
        sm: '22%',
        md: '30%',
        lg: '22%'
      }} title={<CardTitle firstText={i18n._('Achievements')} isFirstGradient colorFrom="#B9C7D4" colorTo="#B9C7D4" mt={6} />} p="lg">
          {achievements.map(item => <VipAchievementItem key={item.id} id={item.id} imgCard={item.imgCard} title={item.title} />)}
        </CarouselLayout>
      </Grid.Col>
    </Grid>;
};